/**
 * Function ini untuk mengubah object menjadi string params
 * yang digunakan ketika melakukan request ke API
 * @example objToParams({a: 1, b: 2}) => 'a=1&b=2'
 */
export const objToParams = (obj: any) => {
  if (!obj) return
  return Object.entries(obj)
    .map(([key, value]) => `${key}=${value}`)
    .join('&')
}
